export default "__VITE_ASSET__Ba39QIR6__"